import { Box, Typography, Card, CardContent, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { AppLayout } from '../components/AppLayout';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { TRUST_COPY } from '../constants/trustCopy';

export interface SettingsPageProps {
  userName?: string;
}

/**
 * SettingsPage - Placeholder for participant settings
 *
 * Actual pause/leave controls will be implemented in Epic 5.
 * For now, shows a "coming soon" message with reassurance.
 */
export function SettingsPage({ userName }: SettingsPageProps) {
  return (
    <AppLayout header={<AppHeader userName={userName} />} footer={<AppFooter />}>
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 300 }}>
          Settings
        </Typography>

        <Card sx={{ maxWidth: 480 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Coming soon
            </Typography>

            <Typography variant="body2" color="text.secondary" paragraph>
              Pause and leave controls will be available here soon.
            </Typography>

            <Typography variant="body2" color="text.secondary" paragraph>
              {TRUST_COPY.CAN_LEAVE_ANYTIME}
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Link
                component={RouterLink}
                to="/"
                sx={{ textDecoration: 'none', color: 'inherit', borderBottom: '1px solid' }}
              >
                Back to home
              </Link>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </AppLayout>
  );
}
